import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import UserContext from "../contexts/UserContext";
import authenticate from './Authenticate';
import { set } from 'mongoose';

const ShowBills = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext);
  const { requestId, zoneId, viewRquestId } = location.state || {};

  const [bills, setBills] = useState([]);
  const [currentRequestId, setCurrentRequestId] = useState(null);
  const [currentBill, setCurrentBill] = useState(null);

  const closeModals = (e) => {
    e.stopPropagation();
    setCurrentRequestId(null);
    setCurrentBill(null);
  };

  const submitData = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("bill", e.target.bill.files[0]);
    formData.append("request", currentRequestId);
    formData.append("zone", zoneId);

    axios.put(`${process.env.REACT_APP_API_URI}/api/bill/updateBillFromZoneReq`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true
    })
      .then((response) => {
        console.log(response.data);
        closeModals(e);
        fetchBills(); // refresh list after upload
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const BillUploadCard = ({ requestId, closeModals }) => (
    <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50" onClick={closeModals}>
      <div className="bg-white rounded-lg shadow dark:bg-gray-700 max-w-2xl w-full mx-3" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-600">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white">Bill Upload</h3>
          <button onClick={closeModals} className="text-gray-400 hover:text-gray-900 dark:hover:text-white">
            ✕
          </button>
        </div>
        <div className="p-4 space-y-4">
          {currentBill ? (
            <>
              <h4>Bill Uploaded</h4>
              <img src={currentBill.file} alt="Bill Preview" />
            </>
          ) : null}
          <form onSubmit={submitData}>
            <input
              type="file"
              name="bill"
              accept=".jpg,.jpeg,.png,.doc,.docx,.pdf"
              className="w-full bg-gray-200 px-3 py-2 rounded"
              required
            />
            <button
              type="submit"
              className="w-full mt-4 bg-blue-600 hover:bg-blue-700 text-white px-3 py-2 rounded"
            >
              Upload Bill
            </button>
          </form>
        </div>
        <div className="flex justify-end p-4 border-t dark:border-gray-600">
          <button onClick={closeModals} className="bg-blue-700 text-white px-4 py-2 rounded mr-2">OK</button>
          <button onClick={closeModals} className="bg-gray-300 px-4 py-2 rounded">Close</button>
        </div>
      </div>
    </div>
  );

  const fetchBills = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URI}/api/bill/by-request-zone`, {
        params: { request: requestId, zone: zoneId },
        withCredentials: true,
      });
      setBills(res.data.data || []);
    } catch (err) {
      console.error("Error fetching bills:", err);
    }
  };

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
      if (user && requestId && zoneId) {
        
        fetchBills();
      }
    }
    startup();
  }, [user]);

  return (
    <>
    
    <div>
        <div className="bg-lime-900  top-0 left-0 right-0 z-10 flex items-center justify-between px-4 text-white py-4 shadow">
        <button onClick={() => navigate(-1)} className="text-xl">←</button>

        <h4 className="text-lg md:text-xl font-semibold truncate max-w-[70%] text-center">
          {viewRquestId || "No Request ID"}
        </h4>

        <button
          onClick={() => setCurrentRequestId(requestId)}
          className="text-sm bg-white text-lime-900 px-3 py-1 rounded hover:bg-gray-100 font-semibold"
        >
          Upload Bill
        </button>
      </div>

      {/* Upload Modal */}
      {currentRequestId === requestId && (
        <BillUploadCard requestId={requestId} closeModals={closeModals} />
      )}
    </div>
    <div className="p-6 pt-[100px]">
      {/* Fixed Header */}
      

      {/* Bills List */}
      {bills.length > 0 ? (
        <div className="space-y-4 mt-4">
          {bills.map((bill, i) => (
            <div key={i} className="border p-4 rounded shadow">
              {/* <p className="font-medium">
                Supplier: {bill.supplier?.name || 'Unknown'}
              </p> */}
              <p>Uploaded: {new Date(bill.createdAt).toLocaleString()}</p>
              <div className="space-y-2 mt-2">
  {bill.file.map((fileUrl, index) => (
    <div key={index}>
      <a
        href={fileUrl}
        target="_blank"
        rel="noreferrer"
        className="text-blue-600 underline"
      >
        View Bill {index + 1}
      </a>
    </div>
  ))}
</div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-600 mt-4">No bills uploaded for this request and zone.</p>
      )}
    </div>
    </>
  );
};

export default ShowBills;
